var modalHelper = new (function ModalHelper($) {
	var self = this;
	var modalTemplate = '';
	
	
	var $lastModalBootstrap = null;
	var $lastModal = null;
	
	var $body = null;
	var opening = false;
	var closing = false;
	
	var animationEndEventType = null;
	
	var getBody = function() {
		if(null === $body) {
			$body = $('body'); 
		}
		return $body;
	};
	
	this.bodyScroll = (new function() {
		var lastDiff = null;
		var $lastElements = null;
		
		var getPadding = function($el) {
			return $el.innerWidth() - $el.width();
		};
		
		var getMargin = function($el) {
			return $el.outerWidth(true) - $el.outerWidth();
		};
		
		var getElements = function() {
			$lastElements = $('[data-fix-modal]');
			return $lastElements;
		};
		
		var getAttributesFromData = function(string) {
			var out = [];
			var splited = string.split(' ');
			for(var i = 0, s = splited.length; i < s; ++i) {
				out.push(splited[i].trim());
			}
			return out;
		};
		
		var fix = function() {
			var $el;
			var fixes;
			for(var i = 0, s = $lastElements.length; i < s; ++i) {
				$el = $($lastElements[i]);
				fixes = getAttributesFromData($el.data('fix-modal'));
				
				for(var z = 0, sz = fixes.length; z < sz; ++z) {
					switch(fixes[z]) {
						case 'margin-add':
								$el.css('margin-right', getMargin($el)+lastDiff);
							break;
						case 'padding-add':
								$el.css('padding-right', getPadding($el)+lastDiff);
							break;
						case 'margin-substract':
							$el.css('margin-right', getMargin($el)-lastDiff);
						break;
						case 'padding-substract':
								$el.css('padding-right', getPadding($el)-lastDiff);
							break;
					}
				}
			}
		};
		
		var unfix = function() {
			var $el;
			var fixes;
			if(null !== $lastElements && null !== lastDiff) {
				for(var i = 0, s = $lastElements.length; i < s; ++i) {
					$el = $($lastElements[i]);
					fixes = getAttributesFromData($el.data('fix-modal'));
					
					for(var z = 0, sz = fixes.length; z < sz; ++z) {
						switch(fixes[z]) {
							case 'margin-add':
									$el.css('margin-right', getMargin($el)-lastDiff);
								break;
							case 'padding-add':
									$el.css('padding-right', getPadding($el)-lastDiff);
								break;
							case 'margin-substract':
								$el.css('margin-right', getMargin($el)+lastDiff);
							break;
							case 'padding-substract':
									$el.css('padding-right', getPadding($el)+lastDiff);
								break;
						}
					}
				}
				
				lastDiff = null;
				$lastElements = null;
			}
		};
		
		this.disable = function() {
			var $body = getBody();
			var baseWidth = $body.width();
			if(null === lastDiff) {
				baseWidth = $body.width();
				$body.addClass('modal-opened');
				lastDiff = $body.width() - baseWidth;
				if($lastModal.hasClass('modal-container--only-mobile')) {
					$('body').addClass('modal-opened--only-mobile');
				}
				
				getElements();
				fix();
			}
		};
		
		this.enable = function(onlyMobile) {
			if(null !== lastDiff) {
				$body.removeClass('modal-opened--only-mobile');
				$body.removeClass('modal-opened');
				
				unfix();
			}
		};
	});
	
	var modalBootstrapHidden = function() {
		this.bodyScroll.enable();
		$lastModalBootstrap.off('hidden.bs.modal', modalBootstrapHidden);
		$lastModalBootstrap.remove();
		$lastModalBootstrap = null;
	};
	
	var mobileOnlyResizeCallback = function() {
		if($lastModal.is(':visible')) {
			self.bodyScroll.disable();
		} else {
			self.bodyScroll.enable();
		}
	};
	
	this.openBootstrap = function($modal) {
		var $body = getBody();
		
		this.closeAll();
		
		$body.append($modal);
		$modal.on('hidden.bs.modal', modalBootstrapHidden.bind(this));
		$lastModalBootstrap = $modal;
		this.bodyScroll.disable();
		$modal.modal('show');
	};
	
	this.closeBootstrap = function() {
		if(null !== $lastModalBootstrap) {
			$lastModalBootstrap.modal('hide');
		}
	};
	
	this.prepareTemplate = function($content) {
		var $modal = $('<div class="modal-container"></div>');
		var $close;
		var $contentBlock = $('<div class="modal__content"></div>');
		var $backgroundBlock = $('<div class="modal__background">');
		var $contentBody = $('<div class="modal__content__body">');
		$contentBody.append($content);
		$modal.append($backgroundBlock);
		$modal.append($contentBlock);
		$close = $('<div type="button" class="modal__close" data-dismiss="modal" aria-label="'+_CLOSE_LABEL+'"></div>');
		$close.append('<span class="modal__close__icon"></span><span class="modal__close__label">'+_CLOSE_LABEL+'</span>');
		$contentBlock.append($close);
		$contentBlock.append($contentBody);
		
		return $modal;
	};
	
	this.open = function($modal) {
		var $body = getBody();
		var $close = $modal.find('.modal__close');
		var $contentBody = $modal.find('.modal__content__body');
		var $background = $modal.find('.modal__background');
		this.closeAll();
		this.opening = true;
		onAnimationEnd([$background, $close], function() {
			onAnimationEnd([$contentBody], function() {
				$modal.trigger('modal.opened');
			});
			$contentBody.addClass('modal--in__content__body');
		});
		
		$body.append($modal);
		$modal.trigger('modal.open');
		
		$modal.find('.modal__close').click(this.close.bind(this));
		$modal[0].offsetWidth;
		$background.addClass('modal--in__background');
		$close.addClass('modal--in__close');
		
		
		
		$lastModal = $modal;
		if($modal.is(':visible')) {
			this.bodyScroll.disable();
		} else {
			$contentBody.addClass('modal--in__content__body');
			$modal.trigger('modal.opened');
		}
		
		if($modal.hasClass('modal-container--only-mobile')) {
			$(window).on('resize', mobileOnlyResizeCallback);
			$modal.on('modal.closed', function() {
				$(window).off('resize', mobileOnlyResizeCallback);
			});
		}
	};
	
	this.close = function() {
		var $close;
		var $contentBody;
		var $background;
		var $modal;
		
		
		if($lastModal) {
			if($lastModal.is(':visible')) {
				$modal = $lastModal;
				$lastModal = null;
				this.closing = true;
				
				$modal.trigger('modal.close');
				$close = $modal.find('.modal__close');
				$contentBody = $modal.find('.modal--in__content__body');
				$background = $modal.find('.modal__background');
				
				onAnimationEnd([$contentBody], function() {
					onAnimationEnd([$background, $close], function() {
						$modal.trigger('modal.closed');
					})
					$background.removeClass('modal--in__background');
					$close.removeClass('modal--in__close');
				});
				
				$contentBody.removeClass('modal--in__content__body');
				
				$modal.on('modal.closed', function() {
					$modal.remove();
					this.bodyScroll.enable();
				}.bind(this));
			} else {
				$lastModal.remove();
			}
		}
	};
	
	this.replaceContent = function($content) {
		if(null === $lastModal) {
			throw 'Modal is closed.';
		}
		
		$lastModal.find('.modal__content__body').empty().append($content);
		return $lastModal;
	};
	
	this.closeAll = function() {
		this.closeBootstrap();
		this.close();
	};
	
	this.isReplacableModalOpened = function() {
		return (null !== $lastModal);
	};
	
})(jQuery);
